<template>
  <div>
    <div class="header mt-3 mt-md-0 edit-page-header">
      <div class="header-body">
        <div class="row align-items-center">
          <div class="col">
            <h6 class="header-pretitle">
              공지 사항
            </h6>
            <h1 class="header-title">
              FIFL 공지사항
            </h1>
          </div>
        </div>
      </div>
    </div>

    <div class="notice-form">
      <el-form
        :model="form"
        label-position="top"
        label-width="100px"
      >
        <el-form-item
          label="제목"
          prop="title"
        >
          <div class="notice-title">
            {{ form.title }}
          </div>
        </el-form-item>
        <el-form-item
          label="내용"
          prop="content"
          style="margin-bottom: 0;"
        >
          <div
            class="notice-content"
            v-html="form.contents"
          />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import dateFns from "date-fns";
import {convertRelativeHref} from "@/utils/etc";
import EditPageHeader from "@/components/EditPageHeader";
import { fiflboxApi } from '@/utils/api';

export default {
	name: "FiflboxNoticeView",
	components: { EditPageHeader },
	data() {
		return {
			form: {
				created: null,
				title: "",
				contents: "",
				images: [],
			},
			noticeId: null,
		};
	},
	computed: {},
	async created() {
		this.noticeId = this.$route.params.noticeId;
		await this.syncNotice();
		await this.$store.dispatch("syncAlerts");
    this.$nextTick(() => {
      convertRelativeHref(".notice-content a")
    })
	},
	methods: {
		async syncNotice() {
      let { data: notice } = await fiflboxApi.v1.getFiflboxNoticeById(this.noticeId);
			this.form = notice;
			this.form.contents = notice.contents.replace(/(\n|\r\n)/g, "<br>");
			this.date = dateFns.parse(notice.published);
		},
	},
};
</script>

<style lang="scss">
.notice-form {
	background-color: #ffffff;
	padding: 30px 25px;
	border-radius: 10px;

	@media screen and (max-width: 768px) {
		padding: 20px;
	}

	.notice-title {
		height: 50px;
		line-height: 48px;
		border-radius: 5px;
		border: solid 1px #d3d3d3;

		font-size: 15px;
		color: #4a4a4a;
		letter-spacing: -0.8px;

		padding: 0 20px;

		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.notice-content {
		height: 330px;
		overflow-y: auto;
		border-radius: 5px;
		border: solid 1px #d3d3d3;

		font-size: 15px;
		color: #4a4a4a;
		letter-spacing: -0.8px;

		padding: 20px;

		min-height: 300px;
	}

	.el-form.el-form--label-top {
		padding: 0;
	}
}
</style>
